export const ocrSourceToTextMap = {
    predictive_coding: 'Predicted by AI',
    ocr: 'From invoice attachment',
    purchase_order: 'Inherited from linked PO',
};
